import React, { useState } from "react";
import "./SaralReviews.css";
import { reviews } from "../utils/hero";

const SaralReviews = () => {
  const filteredReviews = reviews.filter((item) =>
    item.review.toLowerCase().includes("eway") ||
    item.review.toLowerCase().includes("e-way") ||
    item.review.toLowerCase().includes("saral way")
  );

  return (
    <div className="review-container">
      <h2>What Our Clients Say</h2>

      <div className="review-list">
        {filteredReviews.map((r, i) => (
          <ReviewCard key={i} data={r} />
        ))}
      </div>
    </div>
  );
};

const ReviewCard = ({ data }) => {
  const [expanded, setExpanded] = useState(false);

  const toggle = () => setExpanded(!expanded);

  return (
    <div className="review-card">
      <p className={`review-text ${expanded ? "expanded" : ""}`}>
        “{data.review}”
      </p>

      <h4>
        — {data.clientName}
        <br />
        {data.companyName}
      </h4>

      {data.review.length > 150 && (
        <button className="read-more-btn" onClick={toggle}>
          {expanded ? "Read Less" : "Read More"}
        </button>
      )}
    </div>
  );
};

export default SaralReviews;
